import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'SystemLogService',
    controller: 'OperationLog'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'DelItemList',
    'GeItemById',
    'FindByConditions',
    'GetItemPagingList'  
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const OperationLogApi = ZJApi.defineNewApi('OperationLogApi', factory);

export default OperationLogApi;